const A = "https://customer-assets-agu9un31.emergentagent.net/job_trise-siracusa-1/artifacts";

export const MEDIA = {
  // Real Trisé veranda video (mp4 in /public). Empty = use cinematic photo hero.
  heroVideo: "/hero-video.mp4",
  heroImage: `${A}/vlipyvd6_IMG_4877.jpg`, // candlelit plated dish, brass candlestick (moody, cinematic)
  logo: "/trise-logo.png",

  // Real Trisé photography
  tartare: `${A}/z4icohmt_IMG_0491.jpg`, // sesame red-tuna tartare on blue plate, sunlit
  pasta: `${A}/hdtqsm0a_cae6dbb9-8984-4cd1-b17c-ec71302ba03d.webp`, // pasta + white wine in the sunlit veranda
  dessert: `${A}/vlipyvd6_IMG_4877.jpg`, // candlelit plated dish
  social: `${A}/xobzv5vk_IMG_5637.jpg`, // guest in red dress, silver necklace — social dining

  // Signature dishes
  tunaTartare: `${A}/oqn6r0xx_IMG_0170.jpg`, // red tuna tartare, mango, breadcrumbs, mint
  vealTartare: `${A}/scggeo33_IMG_4479.jpg`, // veal tartare, cream, pink tuile
  bruschetta: `${A}/1czao2s3_01FA3449-E90B-4E21-AA3A-B391CBF21D55.JPG`, // bruschetta, walnuts, chili threads
  octopus: `${A}/6bufk9ex_IMG_5522.jpg`, // glazed octopus on chickpea cream, mint
  burger: `${A}/ln5qpci8_Trise%CC%81%20Beef%20Burger.PNG`, // Trisé beef burger

  // Menu pranzo (lunch)
  lunchBoard: `${A}/l1ux2n0s_IMG_2514.webp`, // framed "Trisé Lunch" blackboard (lavagna)
  lunchPolpette: `${A}/3pxb6mwv_CEC9C99C-B775-45EE-8830-7165D71F6563.PNG`, // polpette al sugo in terracotta bowl
  lunchOrecchiette: `${A}/0b93iqkj_IMG_2432.jpg`, // orecchiette with pancetta and grated cheese
  lunchSalmon: `${A}/3h4c6klm_IMG_2563.jpg`, // salmon steak, grilled zucchini, gratin, rosé wine
};

export const CONTACT = {
  phoneDisplay: "351 434 2948",
  phoneTel: "+393514342948",
  whatsapp: "https://wa.me/393514342948",
  instagram: "https://www.instagram.com/trise_bistrot",
  facebook: "https://www.facebook.com/61582233891156",
  tripadvisor:
    "https://www.tripadvisor.it/Restaurant_Review-g187891-d34278155-Reviews-Trise_Bistrot-Syracuse_Province_of_Syracuse_Sicily.html",
  google: "https://www.google.it/search?q=tris%C3%A9+bistrot",
  address: "Corso Gelone, 99, 96100 Siracusa SR, Italia",
  mapEmbed: "https://www.google.com/maps?q=Corso+Gelone+99+96100+Siracusa+SR+Italia&output=embed",
};
